import { useLocation, useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import BASE_URL from "../../configs/api";
import { getProxyUrl } from "../../utils/proxy";
import {
  FiHome,
  FiTag,
  FiFilm,
  FiTv,
  FiStar,
  FiVideo,
  FiChevronRight,
  FiChevronLeft,
  FiFilter,
  FiX,
  FiChevronDown,
  FiChevronUp,
} from "react-icons/fi";
import { FaPlay } from "react-icons/fa";

const CategoryMovies = () => {
  const { slug, ten, loai_phim } = useParams();

  const [phimCategory, setPhimCategory] = useState({
    results: [],
    next: null,
    previous: null,
  });
  const [filteredMovies, setFilteredMovies] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 24;
  const [loading, setLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false); // State để toggle bộ lọc
  const [filters, setFilters] = useState({
    year: "",
    language: "",
    status: "",
    sortBy: "",
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [slug]);

  useEffect(() => {
    const fetchPhimCategory = async () => {
      setLoading(true);
      try {
        let response;
        if (slug && ten) {
          response = await axios.get(`${BASE_URL}/api/phim_category/`, {
            params: {
              theloai: slug,
              page: currentPage,
            },
          });
        } else if (loai_phim) {
          response = await axios.get(`${BASE_URL}/api/phim_category/`, {
            params: {
              loai_phim: loai_phim,
              page: currentPage,
            },
          });
        }
        setPhimCategory(response.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchPhimCategory();
  }, [slug, ten, loai_phim, currentPage]);

  useEffect(() => {
    let filtered = [...phimCategory.results];

    if (filters.language) {
      filtered = filtered.filter(
        (movie) => movie.ngon_ngu && movie.ngon_ngu.includes(filters.language)
      );
    }

    if (filters.status) {
      filtered = filtered.filter(
        (movie) => movie.tinh_trang && movie.tinh_trang.includes(filters.status)
      );
    }

    if (filters.year) {
      filtered = filtered.filter(
        (movie) =>
          movie.nam_phat_hanh && movie.nam_phat_hanh.toString() === filters.year
      );
    }

    if (filters.sortBy) {
      filtered.sort((a, b) => {
        switch (filters.sortBy) {
          case "name_asc":
            return a.ten_phim.localeCompare(b.ten_phim);
          case "name_desc":
            return b.ten_phim.localeCompare(a.ten_phim);
          case "year_desc":
            return (b.nam_phat_hanh || 0) - (a.nam_phat_hanh || 0);
          case "year_asc":
            return (a.nam_phat_hanh || 0) - (b.nam_phat_hanh || 0);
          default:
            return 0;
        }
      });
    }

    setFilteredMovies(filtered);
  }, [filters, phimCategory.results]);

  const resetFilters = () => {
    setFilters({
      year: "",
      language: "",
      status: "",
      sortBy: "",
    });
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const getUniqueYears = () => {
    const years = phimCategory.results
      .map((movie) => movie.nam_phat_hanh)
      .filter(Boolean);
    return [...new Set(years)].sort((a, b) => b - a);
  };

  const hasActiveFilters = Object.values(filters).some(
    (filter) => filter !== ""
  );

  const totalPages = Math.ceil(phimCategory.count / itemsPerPage);

  const goToPrevPage = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const goToNextPage = () => setCurrentPage((p) => Math.min(p + 1, totalPages));

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        <div className="text-center">
          <h1 className="text-xl lg:text-6xl font-bold text-orange-400 mb-4 animate-bounce">
            Đang tải đợi xíu
          </h1>
        </div>
      </div>
    );
  }

  if (phimCategory.results.length === 0) {
    return (
      <div className="min-h-screen flex items-center justify-center text-white">
        <div className="text-center">
          <h1 className="text-xl lg:text-6xl font-bold text-orange-400 mb-4 animate-bounce">
            Đang trong thời gian cập nhật
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="xl:container xl:mx-auto px-4 min-h-screen">
      <div className="p-3.5 rounded-lg mt-4 mb-4 w-full h-auto bg-[#2a2d42] bg-opacity-50">
        <nav className="text-sm text-white flex items-center flex-wrap gap-x-1.5">
          <Link
            to="/"
            className="hover:underline hover:text-orange-300 inline-flex items-center transition-colors duration-150"
          >
            <FiHome className="mr-1.5 w-4 h-4" />
            Trang chủ
          </Link>
          <FiChevronRight className="w-4 h-4 text-neutral-400" />
          <span className="text-orange-300 font-medium inline-flex items-center">
            {ten ? (
              <FiTag className="mr-1.5 w-4 h-4" />
            ) : loai_phim === "phimle" ? (
              <FiFilm className="mr-1.5 w-4 h-4" />
            ) : loai_phim === "phimbo" ? (
              <FiTv className="mr-1.5 w-4 h-4" />
            ) : loai_phim === "hoathinh" ? (
              <FiStar className="mr-1.5 w-4 h-4" />
            ) : (
              <FiVideo className="mr-1.5 w-4 h-4" />
            )}
            {ten
              ? ten
              : loai_phim === "phimle"
              ? "Phim lẻ"
              : loai_phim === "phimbo"
              ? "Phim Bộ"
              : loai_phim === "hoathinh"
              ? "Hoạt Hình"
              : "Không xác định"}
          </span>
        </nav>
      </div>

      <div className="mb-6 md:mb-8 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white font-seogoe relative ">
          {ten ? `${ten}` : "Danh sách phim"}
          <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-orange-500 via-orange-400 to-transparent rounded-full pb-1"></div>
        </h2>
        {phimCategory.count > 0 && (
          <span className="text-sm sm:text-base text-white/70 pt-4 sm:mt-0">
            Hiển thị {filteredMovies.length} / {phimCategory.count} phim
          </span>
        )}
      </div>

      {/* Nút Toggle Bộ Lọc */}
      <div className="mb-4 flex items-center justify-between">
        <button
          onClick={toggleFilters}
          className="flex items-center gap-2 font-medium"
        >
          <FiFilter className="w-5 h-5" />
          {showFilters ? (
            <FiChevronUp className="w-4 h-4" />
          ) : (
            <FiChevronDown className="w-4 h-4" />
          )}
          {hasActiveFilters && (
            <span className="bg-red-500 text-white text-xs px-2 py-0.5 rounded-full ml-1">
              {Object.values(filters).filter((f) => f !== "").length}
            </span>
          )}
        </button>

        {hasActiveFilters && (
          <button
            onClick={resetFilters}
            className="flex items-center gap-1 px-3 py-2 bg-red-500/20 hover:bg-red-500/30 text-red-400 text-sm rounded-lg transition-colors duration-200"
          >
            <FiX className="w-4 h-4" />
            Xóa bộ lọc
          </button>
        )}
      </div>

      {/* Bộ Lọc - Ẩn/Hiện */}
      {showFilters && (
        <div className="mb-6 p-4 bg-[#2a2d42] bg-opacity-50 rounded-lg animate-fade-in">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {/* Ngôn ngữ */}
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Ngôn ngữ
              </label>
              <select
                value={filters.language}
                onChange={(e) =>
                  setFilters({ ...filters, language: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 text-white rounded border border-gray-600 focus:border-orange-500 focus:outline-none text-sm"
              >
                <option value="">Tất cả</option>
                <option value="Vietsub">Phụ Đề</option>
                <option value="Lồng Tiếng">Thuyết Minh</option>
                <option value="Thuyết Minh">Thuyết Minh</option>
              </select>
            </div>

            {/* Trạng thái */}
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Trạng thái
              </label>
              <select
                value={filters.status}
                onChange={(e) =>
                  setFilters({ ...filters, status: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 text-white rounded border border-gray-600 focus:border-orange-500 focus:outline-none text-sm"
              >
                <option value="">Tất cả</option>
                <option value="Hoàn Tất">Hoàn Tất</option>
                <option value="Đang cập nhật">Đang cập nhật</option>
              </select>
            </div>

            {/* Năm phát hành */}
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Năm phát hành
              </label>
              <select
                value={filters.year}
                onChange={(e) =>
                  setFilters({ ...filters, year: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 text-white rounded border border-gray-600 focus:border-orange-500 focus:outline-none text-sm"
              >
                <option value="">Tất cả</option>
                {getUniqueYears().map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>

            {/* Sắp xếp */}
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Sắp xếp theo
              </label>
              <select
                value={filters.sortBy}
                onChange={(e) =>
                  setFilters({ ...filters, sortBy: e.target.value })
                }
                className="w-full px-3 py-2 bg-gray-700 text-white rounded border border-gray-600 focus:border-orange-500 focus:outline-none text-sm"
              >
                <option value="">Mặc định</option>
                <option value="name_asc">Tên A-Z</option>
                <option value="name_desc">Tên Z-A</option>
                <option value="year_desc">Năm mới nhất</option>
                <option value="year_asc">Năm cũ nhất</option>
              </select>
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4 md:gap-3">
        {filteredMovies.map((movie) => (
          <div
            key={movie.slug}
            className="movie-card transition-transform duration-200 ease-in-out"
          >
            <div className="relative rounded-md overflow-hidden group">
              <Link to={`/phim/${movie.slug}`}>
                <div className="relative">
                  <img
                    src={movie.poster_url || getProxyUrl(movie.poster)}
                    alt={movie.ten_phim}
                    className="w-full h-auto aspect-[2/3] object-cover"
                  />
                  <div className="absolute bottom-0 left-1/2 -translate-x-1/2 flex flex-row justify-center items-start z-20">
                    <div className="bg-gradient-to-r from-gray-700 to-gray-600 text-white text-[10px] leading-tight md:text-xs font-semibold px-2 py-0.5 rounded-tl-[0.2rem] shadow-md whitespace-nowrap">
                      {movie.ngon_ngu
                        ? movie.ngon_ngu
                            .replace("Vietsub", "P.Đ")
                            .replace("Lồng Tiếng", "T.M")
                            .replace("Thuyết Minh", "T.M")
                        : "Đang cập nhật"}
                    </div>
                    <div className="bg-gradient-to-r from-[#C02425] to-[#fd9a05] text-white text-[10px] leading-tight md:text-xs font-semibold px-2 py-0.5 rounded-tr-[0.2rem] shadow-md whitespace-nowrap">
                      {(movie.tinh_trang || "Đang cập nhật")
                        .replace(/Hoàn Tất/gi, "HT")
                        .trim() || "Đang cập nhật"}
                    </div>
                  </div>
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="bg-orange-500 rounded-full p-3 shadow-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6 text-white"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M21.409 9.353a2.998 2.998 0 0 1 0 5.294L8.597 21.614C6.534 22.737 4 21.277 4 18.968V5.033c0-2.31 2.534-3.769 4.597-2.648z"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-20 transition duration-300" />
                </div>
              </Link>
            </div>
            <div className="mt-2 text-center">
              <Link
                to={`/phim/${movie.id}`}
                className="text-white text-sm font-medium truncate hover:text-orange-400 cursor-pointer line-clamp-none"
                title={movie.ten_phim}
              >
                {movie.ten_phim}
              </Link>
              <p
                className="text-gray-400 text-xs truncate"
                title={movie.ten_khac}
              >
                {movie.ten_khac}
              </p>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="flex flex-row justify-center items-center mt-10 md:mt-12 space-x-2 sm:space-x-3">
          {/* Nút Trang Trước */}
          <button
            onClick={goToPrevPage}
            disabled={currentPage === 1}
            className="inline-flex items-center justify-center h-10 w-10 sm:w-auto sm:px-4 bg-neutral-700 text-neutral-200 rounded-md shadow-sm 
                 border border-neutral-600 transition-all duration-200 ease-in-out 
                 hover:bg-neutral-600 hover:text-orange-500 hover:border-orange-500 
                 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50
                 disabled:opacity-50 disabled:cursor-not-allowed 
                 disabled:hover:bg-neutral-700 disabled:hover:text-neutral-200 disabled:hover:border-neutral-600"
            aria-label="Trang trước"
          >
            <FiChevronLeft className="h-5 w-5 flex-shrink-0" />
            <span className="hidden sm:inline ml-1.5 text-sm">Trước</span>
          </button>

          {/* Hiển thị Trang Hiện Tại / Tổng Số Trang */}
          <span
            className="flex items-center justify-center h-10 px-4 text-white font-semibold 
                 bg-orange-500 rounded-md text-sm sm:text-base shadow-sm"
            aria-current="page"
          >
            {`${currentPage} / ${totalPages}`}
          </span>

          {/* Nút Trang Sau */}
          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className="inline-flex items-center justify-center h-10 w-10 sm:w-auto sm:px-4 bg-neutral-700 text-neutral-200 rounded-md shadow-sm 
                 border border-neutral-600 transition-all duration-200 ease-in-out 
                 hover:bg-neutral-600 hover:text-orange-500 hover:border-orange-500 
                 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-opacity-50
                 disabled:opacity-50 disabled:cursor-not-allowed
                 disabled:hover:bg-neutral-700 disabled:hover:text-neutral-200 disabled:hover:border-neutral-600"
            aria-label="Trang sau"
          >
            <span className="hidden sm:inline mr-1.5 text-sm">Sau</span>
            <FiChevronRight className="h-5 w-5 flex-shrink-0" />
          </button>
        </div>
      )}
    </div>
  );
};

export default CategoryMovies;
